import {Box} from "@mui/material";
import {useContext, useState} from "react";
import {AppContext} from "../../common/appWrapper/AppWrapper";
import YearTabs from "../../common/yearTabs/YearTabs";
import PageSpinner from "../../common/appSpinner/PageSpinner";
import Cruises from "./cruises/Cruises";


const CruisesPage = () => {
  const {appLoadersCache} = useContext(AppContext);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  return (
    <Box sx={{mt: 2}}>
      {appLoadersCache.getCruisesLoading ?
        <PageSpinner/> :
        <>
          <YearTabs setSelectedYear={setSelectedYear}/>
          <Cruises selectedYear={selectedYear}/>
        </>
      }
    </Box>
  )
}

export default CruisesPage;